import { round } from '@homamo/meadow-utils';

import defaults from '../../defaults';

export default function (annualInterestRate) {
  const monthlyInterestRate = annualInterestRate / 12;
  return round(monthlyInterestRate, defaults.decimalDigits);
}
